import { css } from 'styled-components';

import {
	SizeDetails,
	ThemeDetails,
} from '../tokens/button.js';
import getFontDetailsByLabel from '../tokens/typography.js';
import { easingValues, easing } from '../tokens/easing.js';

// export const getButtonDetailsBySize = (size: ButtonSizes) => { TODO: Fix me when typesafe
export const getButtonDetailsBySize = ({ size, iconPresent }) => {
	const { fontLabel, padding, flexGap, borderRadius,height } = SizeDetails[size];
	return css`
		padding: ${padding};
		gap: ${iconPresent && flexGap};
		border-radius: ${borderRadius};
		${getFontDetailsByLabel(fontLabel)};
		height: ${height};
	`;
};

export const getButtonDetailsByTheme = ({
	color,
	variant,
	isLoading,
	disabled
}) => {
	// ({color,variant,}: {color: ColorTypes; variant: VariantTypes;}) => {
	const themeColor = ThemeDetails[color]; // const themeColor = ThemeDetails[color] as Record<PrimaryVariants | SecondaryVariants,ThemeDetailType>;
	const themeDetail = themeColor[variant];
	const {
		fontColor,
		shadow,
		backgroundColor,
		activeBackgroundColor,
		disabledBackgroundColor,
		disabledFontColor,
		borderColor,
		disabledBorderColor,
	} = themeDetail;
	return css`
		background-color: ${backgroundColor};
		border: ${borderColor ? `1px solid ${borderColor}` : 'none'};
		color: ${fontColor};
		${!isLoading &&
		!disabled &&
		`
			&:hover {
				background-color: ${activeBackgroundColor};
			}
			&:active {
				background-color: ${activeBackgroundColor};
				transform: scale(0.97);
				transition-property: transform;
				transition-duration: 300ms;
				transition-timing-function: ${easingValues[easing.FUNC]};
			}
		`}
		&:disabled {
			background-color: ${disabledBackgroundColor};
			border: ${disabledBorderColor
				? `1px solid ${disabledBorderColor}`
				: 'none'};
			color: ${disabledFontColor};
		}
	`;
};
